import { Typography } from '@euler/app/components/typography';
import { Icon } from '@euler/components/Icomoon';
import { HStack } from '@euler/components/layout/Stack';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo, ReactNode } from 'react';
import { View } from 'react-native';
import { TOKENS } from '../constants';

export const InfoCell = memo(
  ({
    label,
    value,
    icon,
    iconNode,
    size,
  }: {
    icon?: 'clock' | 'user' | 'clipboard';
    iconNode?: ReactNode;
    label: string;
    value: string | null | undefined;
    /** Text size (base px); defaults to 12. */
    size?: number;
  }) => {
    const { rpx } = useResponsiveContext();
    const textSize = rpx(size ?? 12);
    return (
      <HStack
        css={`
          width: 50%;
          padding: ${rpx(3)}px 0;
        `}
        justifyContent="flex-start"
        alignItems="center"
      >
        <View
          css={`
            width: ${rpx(14)}px;
            align-items: center;
          `}
        >
          {iconNode ??
            (icon ? (
              <Icon name={icon} size={rpx(11)} color={TOKENS.textFaint} />
            ) : null)}
        </View>
        <Typography.Label
          size={textSize}
          lineHeight={textSize + rpx(4)}
          color={TOKENS.textFaint}
          css={`
            margin-left: ${rpx(6)}px;
          `}
        >
          {label}{' '}
          <Typography.Text
            size={textSize}
            lineHeight={textSize + rpx(4)}
            color={TOKENS.textPrimary}
          >
            {value ?? '-'}
          </Typography.Text>
        </Typography.Label>
      </HStack>
    );
  },
);
